import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetClaim = (claimId) => axios.get(`${apiPaths.claimsBase}/${claimId}`);
const onGetClaimHistory = (claimId) => axios.get(`${apiPaths.claimsBase}/${claimId}/history`);

const onUpdateClaim = (claim) => axios.put(`${apiPaths.claimsBase}/${claim.id}`, claim);
const onCreateClaim = (claimData) => axios.post(apiPaths.claimsBase, claimData);

const onUpdateClaimStatus = (claimId, status) => axios.patch(`${apiPaths.claimsBase}/${claimId}/status=${status}`);

const onGetClaimOrganizationsWithAccess = (claimId) =>
  axios.get(`${apiPaths.claimsBase}/${claimId}/organizations-with-access`);

const onGetClaimPdfSummary = (claimId) =>
  axios.get(`${apiPaths.claimsBase}/${claimId}/pdf-summary`, {
    responseType: 'blob',
    headers: { Accept: 'application/pdf' }
  });

const onGetRecommendedSettlementPayeeData = (claimId) =>
  axios.get(`${apiPaths.claimsBase}/${claimId}/recommended-settlement-payee-data`);

export {
  onGetClaimHistory,
  onGetClaim,
  onUpdateClaim,
  onCreateClaim,
  onUpdateClaimStatus,
  onGetClaimPdfSummary,
  onGetClaimOrganizationsWithAccess,
  onGetRecommendedSettlementPayeeData
};
